export class SystemUser { 
    id : number; 
    groupName : string;
    userName : string;
    normalizedUserName : string;
    fullName : string;
    passwordHash : string; 
    accountType : number;
    isActivity : boolean;
    schoolNumber : number;
    schoolId : number;
    userId : string;
    oldPassword : string;
	password : string;
	confirmPassword : string;
}